export default __webpack_public_path__ + "static/media/6990-button.cf32f585.svg";